
import { createApp, type App } from 'vue';
import { i18n } from './i18n';
import EditionUpgradeWrap from './components/EditionUpgradeWrap.vue';
import type { EditionUpgradeAction, EditionUpgradeOptions } from './types';
import type { UsageAmountWhere } from './constants';
import { UpgradeUsageType } from './constants';
import { controlDeferred } from '@eureka/utils/control';
import { getIfHasTrialPackage, packageInfoDeferred } from '@eureka/utils/package-info';

// 打开升级弹窗
export function openEditionUpgrade(options: EditionUpgradeOptions): Promise<EditionUpgradeAction> {
    const div = document.createElement('div');
    div.setAttribute('data-theme', 'patsnapRD');
    div.classList.add('edition-upgrade-wrap');
    document.body.appendChild(div);

    const unmountApp = (app: App) => {
        app.unmount();
        document.body.removeChild(div);
    };

    const promise = new Promise<EditionUpgradeAction>((resolve) => {
        const app = createApp(EditionUpgradeWrap, {
            ...options,
            onClose: (action: EditionUpgradeAction = 'close') => {
                resolve(action);
                unmountApp(app);
            },
        });
        app.use(i18n);
        app.mount(div);
    });

    return promise;
}

// 试用结束
export function prepareFirstLoginAfterTrial(useWhere: UsageAmountWhere) {
    openEditionUpgrade({ usageType: UpgradeUsageType.TRIAL_END, useWhere });
}

/**
 * 免费版升级
 * @returns true 代表后续流程继续
 */
export async function invokeEditionUpgrade(useWhere: UsageAmountWhere) {
    const [packages, { freemium }] = await Promise.all([packageInfoDeferred.promise, controlDeferred.promise]);
    const ifNeedOpen = getIfHasTrialPackage(packages) || freemium;

    // 使用次数超限弹窗
    if (ifNeedOpen) {
        openEditionUpgrade({ usageType: UpgradeUsageType.TRY_PREMIUM, useWhere });
        return false;
    }
    return true;
}

/**
 * 判断用量受限
 * techSeek: 90164076
 * techMind: 90164072
 * techRisk: 90164082
 * techResearch: 90112037
 * @param errorCode
 * @returns
 */
export function prepareInterceptorEdition(code: number | string) {
    return [90112037, 90164072, 90164076, 90164082].includes(Number(code));
}
